export const noteMapping = [
  'ไม่มี',
  'หมุนเข็ม ดด/ปป',
  'หมุนเข็ม วว/ดด/ปป',
  'หมุนเข็ม วว/ดด/ปป+Materail',
  'หมุนเข็ม Materail',
  'หมุนเข็ม part',
  'หมุนเข็ม part + Materail',
  'เปลี่ยนก้อน Insert',
  'เปลี่ยนก้อน Part',
  'other_custom_text',
]

export const noteMappingHashMap = {
  'rotate_needle_dd/pp': 'หมุนเข็ม ดด/ปป',
  'rotate_needle_ww/dd/pp': 'หมุนเข็ม วว/ดด/ปป',
  'rotate_needle_ww/dd/pp+material': 'หมุนเข็ม วว/ดด/ปป+Materail',
  'rotate_needle_material': 'หมุนเข็ม Materail',
  'rotate_needle_part': 'หมุนเข็ม part',
  'rotate_needle_part+material': 'หมุนเข็ม part + Materail',
  'change_insert_block': 'เปลี่ยนก้อน Insert',
  'change_part_block': 'เปลี่ยนก้อน Part',
  'other_custom_text': 'อื่นๆ (ข้อความพิมพ์)',
};

// Shared {value,label} option list for the notes / insert-change-type dropdowns.
export const noteMappingOptions = (): { value: string; label: string }[] =>
  noteMapping.map((value: string) =>
    value === 'other_custom_text'
      ? { value, label: noteMappingHashMap[value] }
      : { value, label: value },
  );

export enum NoteMappingKeys {
  ROTATE_NEEDLE_DD_PP = 'rotate_needle_dd/pp',
  ROTATE_NEEDLE_WW_DD_PP = 'rotate_needle_ww/dd/pp',
  ROTATE_NEEDLE_WW_DD_PP_MATERIAL = 'rotate_needle_ww/dd/pp+material',
  ROTATE_NEEDLE_MATERIAL = 'rotate_needle_material',
  ROTATE_NEEDLE_PART = 'rotate_needle_part',
  ROTATE_NEEDLE_PART_MATERIAL = 'rotate_needle_part+material',
  CHANGE_INSERT_BLOCK = 'change_insert_block',
  CHANGE_PART_BLOCK = 'change_part_block',
  OTHER_CUSTOM_TEXT = 'other_custom_text',
}


export const StorageLocationList = [
  "โรง1 ด้านหลังฝั่งวัตถุดิบ",
  "โรง1 ด้านหลังฝั่ง350T",
  "โรง2 ด้านหลัง",
  "โรง4",
  "ห้อง A",
  "ห้อง B",
  "ห้อง C",
  "ห้อง D",
  "ห้อง E",
  "ห้อง F",
  "ห้อง 350T",
  "INJ2-1",
  "INJ2-2",
]